import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import IconWithText from '../Icons/IconWithText';

const MainMenuItem = ({ title, href, active, iconName, children }) => {
  const linkClass = classnames('main-menu__link link h-100 d-flex align-items-center fw-bold text-uppercase letter-spacing-s m-b-0 pos-relative', {
    'main-menu__link--active': active,
  });

  return (
    <li className="main-menu__item h-100">
      <a className={linkClass} href={href}>
        <IconWithText name={iconName} size="m" fill="white">
          <span>{title}</span>
        </IconWithText>
      </a>
      {children}
    </li>
  );
};

MainMenuItem.propTypes = {
  title: PropTypes.string.isRequired,
  href: PropTypes.string.isRequired,
  active: PropTypes.bool,
  iconName: PropTypes.string.isRequired,
  children: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
};

export default MainMenuItem;



// WEBPACK FOOTER //
// ./library/app/components/Global/Menus/MainMenuItem.js